import { MultiInput } from "components/FormControls/MultiInput/MultiInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { maxVisibleConditionDataCount } from "components/Layout/Segment/SegmentForm/SegmentForm";
import { useMessage } from "hooks/intl";
import { get } from "lodash";
import { PostalCodeType } from "types/segments";
import { MoreElements } from "../../../../MoreElements/MoreElements";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesPostalCode: PostalCodeType = {
  postal: [],
  type: "postal",
};

export function PostalCode({
  formField,
  values,
  readOnly,
}: {
  formField: string;
  values: any;
  readOnly?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const value = get(values, formField);

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          {message({ id: "is_one_of" }).toLocaleLowerCase()}{" "}
          {value?.postal
            ?.slice(0, maxVisibleConditionDataCount)
            ?.map((item: string, index: number) => (
              <div className={classes.box} key={index}>
                {item}
              </div>
            ))}
          <MoreElements
            totalItemsNumber={value?.postal?.length}
            tooltipData={{
              type: "labels",
              data: value?.postal?.slice(maxVisibleConditionDataCount),
            }}
          />
        </>
      ) : (
        <MultiInput
          label={<RequiredFieldLabel text={message({ id: "postalCode" })} />}
          className={`${classes.input} ${classes.fullWidth}`}
          formField={`${formField}.postal`}
          helperText={message({ id: "multiInputHelper" })}
          placeholder={message({ id: "add" })}
          data-test-id="segment-conditions-postal-code"
        />
      )}
    </>
  );
}
